import { h } from 'vue'
import { ElNotification } from 'element-plus'

const MAX_WARNINGS_SHOWN = 5

export function showErrorMessage(error: any, defaultMessage: string, title = 'Error'): void {
  const message = error?.response?.data?.message || defaultMessage || ''
  ElNotification.error({
    title,
    message,
    type: 'danger',
  });
}

export function showSuccessMessage(message: string, title = 'Done', duration = 3000 ): void {
  ElNotification.success({
    title,
    message,
    type: 'success',
    duration,
  });
}

export function showWarningMessage(message: string, title = 'Warning'): void {
  ElNotification.warning({
    title,
    message,
    type: 'warning',
  });
}

// Several warnings go into one notification: separate ElNotification calls made in the
// same tick stack at the same offset (a new one has no height yet), so only the last is visible.
export function showWarningList(warnings: string[], title = 'Warning'): void {
  if (!warnings.length) return

  const shown = warnings.slice(0, MAX_WARNINGS_SHOWN)
  const hidden = warnings.length - shown.length

  ElNotification.warning({
    title: warnings.length > 1 ? `${title}s (${warnings.length})` : title,
    // VNodes, not an HTML string: warnings are plain text from the API
    message: h('div', { class: 'notification-list' }, [
      h('ul', shown.map(warning => h('li', warning))),
      hidden > 0 ? h('p', `…and ${hidden} more`) : null,
    ]),
    // stays until closed: it usually explains what was not done
    duration: 0,
  });
}
